import {Card} from '../../../../utils/Deck'

export function sortCardsByWeight(cards: Card[], trump: Card): Card[] {
    cards.sort((a, b) => a.weight(trump) - b.weight(trump))
    return cards
}
